var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLocationFill = function SvgIconLocationFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.333A4.664 4.664 0 0 0 3.333 6c0 2.217 1.405 4.937 4.215 8.157a.599.599 0 0 0 .904 0c2.81-3.22 4.215-5.94 4.215-8.157A4.664 4.664 0 0 0 8 1.333zm0 6.334a1.668 1.668 0 1 1 .002-3.336A1.668 1.668 0 0 1 8 7.667z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};

export default SvgIconLocationFill;